import CssBaseline from '@mui/material/CssBaseline';
import LoginContainer from 'components/login/LoginContainer';
import LoginForm from 'components/login/LoginForm';

function LoginPage(): JSX.Element {
  return (
    <>
      <CssBaseline />
      <LoginContainer value="Sign In" component={<LoginForm />} />
    </>
  );
}

export default LoginPage;
